module.exports = __webpack_public_path__ + "static/media/Price-listIcon.0205ddb9.png";